import React, { Component } from 'react';
import { Spinner } from "react-bootstrap";
import Footer from "../components/Footer";
import Sidebar from '../components/Sidebar';

// Keys that belong to the user portal - clear only these on logout
const USER_PORTAL_KEYS = [
  'token', 'userid', 'email', 'licenseId', 'rrr',
  'formid', 'DOB', 'surname', 'firstName', 'title', 'gender', 'state', 'lga',
  'recid', 'amount', 'description', 'category', 'serviceTypeId',
  'license_id', 'lead_food_scientist', 'license_number', 'reg_number',
  'nationality', 'orgName', 'orgAddress', 'processEquipm', 'productBrands',
  'natureBus', 'companySize', 'code', 'reset-phone', 'user-reset-id',
  'paymentSuccessful', 'remita-id', 'payment_category', 'paymentsubcategory'
];

class Logout extends Component {

  componentDidMount(){
    // Clear only user portal keys to avoid affecting company portal session
    USER_PORTAL_KEYS.forEach(key => localStorage.removeItem(key));
    if(localStorage.getItem("token") === null ){
      this.props.history.push("/login")
    }
  }

  render() {
    return (
      <div className="container">
        <Sidebar />
         <div className="text-center mt-6 d-flex justify-content-center">
        <Spinner animation="border" variant="danger" size="lg" />
        </div>
      </div>
    );
  }
}

export default Logout;
